module.exports = __webpack_public_path__ + "img/area52_edible_1.5157fcd2.png";